import commonTableColumns from '@root/components/table/commonTableColumns';
import ListTooltip from '@root/components/v2/ui-elements/ListTooltip';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import EllipsesCountTooltip from '@root/components/v3/ellipsesCountTooltip';
import { VulnerabilityCounts } from '../VulnerabilityCounts';
import { Box } from '@mui/material';
import ClustersIcon from '@root/assets/svg/Dashboard/ClustersIcon';

export const sbomColumns = [
  {
    ...commonTableColumns.resources({
      field: 'clusters',
      headerName: 'Cluster',
      nameKey: 'cluster',
      // Same cluster icon as the dashboard's Kubernetes Security Posture card, on a tint of its purple.
      icon: <ClustersIcon width="20px" height="20px" />,
      iconBackground: 'rgba(147, 51, 234, 0.12)',
    }),
    sortable: false,
  },
  {
    field: 'name',
    headerName: 'Component',
    width: 230,
    renderCell: params => {
      return (
        <Tooltip title={params?.row?.name ?? '-'}>
          <Text fontWeight={500} className="SingleLine">
            {params?.row?.name ?? '-'}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'version',
    headerName: 'Version',
    width: 230,
    renderCell: params => {
      return (
        <Tooltip title={params?.row?.version ?? '-'}>
          <Text fontWeight={500} className="SingleLine">
            {params?.row?.version ?? '-'}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 200,
    renderCell: params => {
      return (
        <Tooltip title={params?.row?.type ?? '-'}>
          <Text fontWeight={500} className="SingleLine">
            {params?.row?.type ?? '-'}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'fix_version',
    headerName: 'Fix Version',
    renderCell: params => {
      return (
        <Tooltip title={params?.row?.version ?? '-'}>
          <Text fontWeight={500} className="SingleLine">
            {params?.row?.version ?? '-'}
          </Text>
        </Tooltip>
      );
    },
    width: 250,
  },
  {
    field: 'images',
    headerName: 'Images',
    renderCell: params => {
      const value = params?.row?.related_images;
      return (
        <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
          <Tooltip title={value[0]}>
            <Text font="medium" className="SingleLine">
              {value[0]}{' '}
            </Text>
          </Tooltip>
          {value.length > 1 ? (
            <ListTooltip list={value.slice(1)}>
              <div style={{ color: '#5AB3FF' }}>+{value.length - 1}</div>
            </ListTooltip>
          ) : null}
        </div>
      );
    },
    width: 300,
  },
  {
    field: 'workloads',
    headerName: 'Workloads',
    renderCell: params => {
      const value = params?.row?.related_workloads ?? params?.row?.related_workload;
      return (
        <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
          <Tooltip title={value[0]}>
            <Text font="medium" className="SingleLine">
              {value[0]?.workload_name ?? '-'}{' '}
            </Text>
          </Tooltip>
          {value.length > 1 ? (
            <ListTooltip list={value.slice(1).map(item => item?.workload_name ?? '-')}>
              <div style={{ color: '#5AB3FF' }}>+{value.length - 1}</div>
            </ListTooltip>
          ) : null}
        </div>
      );
    },
    width: 250,
    // flex: 1,
  },
  {
    field: 'namespaces',
    headerName: 'Namespaces',
    renderCell: params => {
      const value = params?.row?.related_namespaces;
      return (
        <div style={{ display: 'flex', gap: '6px', width: '100%' }}>
          <Tooltip title={value[0]}>
            <Text font="medium" className="SingleLine">
              {value[0]}{' '}
            </Text>
          </Tooltip>
          {value.length > 1 ? (
            <ListTooltip list={value.slice(1)}>
              <div style={{ color: '#5AB3FF' }}>+{value.length - 1}</div>
            </ListTooltip>
          ) : null}
        </div>
      );
    },
    width: 200,
  },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return !params.row?.vulnerability_counts ? (
        '-'
      ) : (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      );
    },
  },
];

export const cveSideoverlayWorkload = [
  commonTableColumns.environment('account_id', 'cluster'),

  {
    field: 'images',
    headerName: 'Images',
    renderCell: params => {
      return <EllipsesCountTooltip labels={params?.row?.related_images} />;
    },
    width: 350,
  },
  {
    field: 'workload',
    headerName: 'Workload ',
    width: 200,
    renderCell: params => {
      return (
        <Box display={'flex'} flexDirection={'column'} gap={'4px'} width={'100%'}>
          <Tooltip title={params?.row?.workload_name ?? '-'}>
            <Text className="m-0 SingleLine">{params?.row?.workload_name ?? '-'}</Text>
          </Tooltip>
          <Tooltip title={params.row.workload_kind}>
            <Text className="m-0 SingleLine">{params?.row?.workload_kind ?? '-'}</Text>
          </Tooltip>
        </Box>
      );
    },
  },

  {
    field: 'namespace',
    headerName: 'Namespace',
    width: 200,
  },

  {
    field: 'pod',
    headerName: 'Pod',
    width: 230,
    renderCell: params => {
      return <EllipsesCountTooltip labels={params?.row?.runtime_instances?.map(item => item?.pod_name)} />;
    },
  },

  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return !params.row?.vulnerability_counts ? (
        '-'
      ) : (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      );
    },
  },
];
